<template>
  <span>
    <a href="javascript:;" @click.prevent="$bvModal.show(modalId)" class="pl-1">
      <i class="fa fa-lg fa-send"></i>
    </a>
    <b-modal :id="modalId" title="Enviar reporte por correo" @show="onShow">
      <div class="text-center">
        <b-spinner v-if="loading"></b-spinner>
      </div>
      <b-form v-if="ready === true">
        <b-form-group
          label="Email"
          label-for="email"
          description="Para multiples correos, ingréselos separados por coma."
        >
          <b-form-input id="email" type="email" v-model="email" required></b-form-input>
        </b-form-group>
        <b-form-group label="Asunto" label-for="subject">
          <b-form-input id="subject" v-model="subject" required></b-form-input>
        </b-form-group>
        <b-form-group label="Mensaje" label-for="message">
          <b-form-textarea id="message" rows="8" v-model="message" required></b-form-textarea>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide(modalId)">Cerrar</b-button>
        <b-button variant="primary" @click.prevent="sendEmail()" :disabled="loading"> Enviar </b-button>
      </template>
    </b-modal>
  </span>
</template>

<script>
export default {
  name: "EmailModal",
  props: ["item", "productores"],
  computed: {
    modalId() {
      return `email-modal-${this.item.id}`;
    }
  },
  data() {
    return {
      ready: false,
      loading: true,
      email: "",
      cc: "",
      subject: "",
      message: ""
    };
  },
  methods: {
    onShow() {
      this.loading = true;
      this.email = "";
      this.cc = "";
      this.subject = `Reporte de inspección #${this.item.id}`;
      this.message = `Estimado productor, \n\nAdjunto se encuentra el reporte de inpeccion #${this.item.id}.\n\nSaludos,\nDepartamento de calidad\nChilean Marroni Farms`;
      this.email = this.getEmails(this.item.productor);
      this.loading = false;
      this.ready = true;
    },
    getEmails(productor) {
      const selectedProductor = this.productores.find((item) => item.nombre === productor);

      return selectedProductor ? selectedProductor.correos : "";
    },
    updateRow() {
      // Payload must have this schema {calidad:{...}}
      let payload = {};
      payload["calidad"] = { estado: "enviado" };
      this.$axios
        .put(`https://api.sheety.co/17a15e538248668e7a07764e201fdfa9/calidadCmf/calidad/${this.item.id}`, payload)
        .then(
          (response) => {
            console.log(`Row ${this.item.id} updated!`);
            this.$emit("update-row", this.item);
          },
          (error) => {
            console.log(error);
            this.$bvToast.toast("Error al actualizar el registro", {
              title: "Error",
              variant: "danger",
              solid: true
            });
          }
        );
    },
    sendEmail() {
      this.loading = true;
      const payload = {
        email: this.email,
        cc: this.cc,
        subject: this.subject,
        message: this.message,
        item: this.item
      };
      this.$axios
        .post(`/production/marroni/email_pdf`, payload)
        .then((response) => {
          this.updateRow();
          this.$bvModal.hide(this.modalId);
          this.$bvToast.toast("Email enviado", {
            title: "Éxito",
            variant: "success",
            solid: true
          });
        })
        .catch((error) => {
          this.$bvToast.toast("Error al enviar el email", {
            title: "Error",
            variant: "danger",
            solid: true
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
